module.exports = __webpack_public_path__ + "img/vehicle_img.b20620ed.svg";